import type { FC } from 'react';

import defaultBg from '@wwe-portal/ui/assets/images/offer/offer-default-bg.svg';
import { DynamicImage } from '@wwe-portal/ui/components/dynamic-image/dynamic-image';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';

import { type OfferCardProps } from '../type';
import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

const GAP = 12;
const DEFAULT_BREAKPOINTS = {
  base: 356,
  sm: 600,
  md: 356,
  lg: 476,
  xl: 356,
  '2xl': 424,
  '3xl': 400,
};

const scaleDownDefaultBreakpoint = (defaultValue: number, time: number) => {
  return Math.ceil((defaultValue - (time - 1) * GAP) / 2);
};

const scaleDownDefaultBreakpoints = (time: number) => {
  return {
    base: scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS.base, time),
    sm: scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS.sm, time),
    md: scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS.md, time),
    lg: scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS.lg, time),
    xl: scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS.xl, time),
    '2xl': scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS['2xl'], time),
    '3xl': scaleDownDefaultBreakpoint(DEFAULT_BREAKPOINTS['3xl'], time),
  };
};

const imageWidthMap = {
  [OfferCardTypeEnum.SINGLE1]: DEFAULT_BREAKPOINTS,
  [OfferCardTypeEnum.SINGLE2]: scaleDownDefaultBreakpoints(2),
  [OfferCardTypeEnum.SINGLE3]: scaleDownDefaultBreakpoints(3),
};

export const ResponseOfferCardBackground: FC<
  Pick<OfferCardProps, 'backgroundImage' | 'dynamicBackgroundImage' | 'type'>
> = ({ backgroundImage, dynamicBackgroundImage, type }) => {
  const { base, sm, lg, xl2, xl3 } = useResponsive();
  const breakpoint = Object.entries({ base, sm, lg, xl2, xl3 }).find(
    ([, value]) => value
  )?.[0] as never;
  if (!type) return null;
  const resizedWidth = imageWidthMap[type][breakpoint];

  return (
    <DynamicImage
      className="h-full w-full object-fill"
      defaultUrl={backgroundImage ?? defaultBg}
      dynamicUrl={dynamicBackgroundImage}
      resizedWidth={resizedWidth}
    />
  );
};
